import './style/index.less';
import LoginSwitch from './LoginSwitch';

export default LoginSwitch;
